import { action, computed, observable } from "mobx";
import { create, persist } from "mobx-persist";
import { Locales } from "../i18n/Locales";
import { DEFAULT_LOCALE } from "../i18n/util";

const ERROR_QUEUEING = false;

class GeneralStore {
    @observable _hideNavigation = 0;
    @computed get hideNavigation() {
        return this._hideNavigation > 0;
    }

    @persist @observable googleAnalyticsCookies = false;

    @persist @observable acceptedCookies?: boolean = undefined;

    @observable mobileMenuOpen = false;

    @observable locale: Locales = DEFAULT_LOCALE;
    @observable isLoading = false;

    @observable lastLocation: Location | null = null;

    @observable _error: { message: string; error?: any }[] = [];

    // Returns the first error in the queue
    get error() {
        return this._error.length > 0 ? this._error[0] : undefined;
    }

    constructor() {
        this.locale = DEFAULT_LOCALE;
    }

    @action setError(message: string, error?: any) {
        if (ERROR_QUEUEING) {
            this._error = this._error.concat([{ message, error }]);
        } else {
            this._error = [{ message, error }];
        }
    }

    @action popError() {
        if (ERROR_QUEUEING) {
            this._error = this._error.slice(1);
        } else {
            this._error = [];
        }
    }
}

const hydrate = create({
    storage: require("localforage")
});

export const generalStore = new GeneralStore();

hydrate("generalStore", generalStore).then(() => {
    if (!generalStore.acceptedCookies) {
        generalStore.acceptedCookies = false;
    }
});
